// extracted by mini-css-extract-plugin
export var errorContainer = "error-fallback-module--error-container--dOcue";